import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  TableConfigBuilder,
  deleteAction,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { CustomEventModel } from '@models/custom-event.model';

export type CustomEventFieldCellContext = CellTemplateContext<CustomEventModel.CustomEventField>;

export interface CreateCustomEventsEditTableConfigDependencies {
  nameCellTemplate: TemplateRef<CustomEventFieldCellContext>;
  typeCellTemplate: TemplateRef<CustomEventFieldCellContext>;
}

export function createCustomEventsEditTableConfig(
  dependencies: CreateCustomEventsEditTableConfigDependencies,
): DatasetTableConfig<CustomEventModel.CustomEventField> {
  const builder = new ColumnBuilder<CustomEventModel.CustomEventField>();

  return new TableConfigBuilder<CustomEventModel.CustomEventField>()
    .columns([
      builder
        .column('name')
        .label('EDIT_CUSTOM_EVENT.TABLE.NAME')
        .width('minmax(100px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .mobileVisible()
        .cardMode('label-only')
        .build(),

      builder
        .column('type')
        .label('EDIT_CUSTOM_EVENT.TABLE.TYPE')
        .width('minmax(100px, 0.7fr)')
        .cellTemplate(dependencies.typeCellTemplate)
        .mobileVisible()
        .cardMode('label-only')
        .build(),
    ])
    .actions([
      deleteAction<CustomEventModel.CustomEventField>(),
    ])
    .build();
}

